import { render } from "./Asset_disposal_report.vue?vue&type=template&id=5e1d205b&scoped=true"
import script from "./Asset_disposal_report.vue?vue&type=script&lang=js"
export * from "./Asset_disposal_report.vue?vue&type=script&lang=js"

import "./Asset_disposal_report.vue?vue&type=style&index=0&id=5e1d205b&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1d205b"]])

export default __exports__